import { Filters, storageHelper, Storages } from '@spo/logic';
import { Header } from '@spo/storybook';
import { useTranslation } from 'react-i18next';
import { useRoles } from '../../contexts/RolesContext';
import { environment } from '../../environments/environment';
import { ErrorPage } from '../errorPage';
import { Layout } from '../layout';
import './massEdit.scss';
import { ModelMassEdit } from './ModelMassEdit';
import { SmMassEdit } from './SmMassEdit';

export enum ModalErrorType {
  SM = 'SM',
  MODEL = 'MODEL',
  ERROR_API = 'ERROR_API',
}

export const MassEdit = () => {
  const params = new URLSearchParams(document.location.search);
  const smIds = params.get('smIds')?.split(',');
  const modelIds = params.get('modelIds')?.split(',');
  const { hasRoleProductLeader } = useRoles();

  const selectedFilters = storageHelper.getItem<string>(
    'personal-offer_my-view_selected-filters',
    Storages.session,
  );

  const selectedFiltersParse: Filters = selectedFilters
    ? JSON.parse(selectedFilters)
    : {
        productManagerIds: [],
        productNatureIds: [],
        retailFamilyIds: [],
        segmentationIds: [],
        sportIds: [],
        status: [],
      };

  const { t } = useTranslation();

  return (
    <Layout>
      {hasRoleProductLeader ? (
        <>
          <Header
            logoTitle={t('header.mass-edit_title')}
            env={!environment.production ? environment.env : undefined}
            darkSkin
          />
          <div data-testid="mass-edit" className="mass-edit">
            {smIds && (
              <SmMassEdit
                smIds={smIds}
                selectedFilters={selectedFiltersParse}
              />
            )}
            {modelIds && (
              <ModelMassEdit
                modelIds={modelIds}
                selectedFilters={selectedFiltersParse}
              />
            )}
          </div>
        </>
      ) : (
        <ErrorPage
          errorPageTitle={t('no-access-page.title')}
          errorMessage={t('no-access-page.subtitle')}
        />
      )}
    </Layout>
  );
};
